import { useState } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { AdminProvider, useAdminState } from './context/AdminContext'
import { Shell } from './components/Shell'
import { LoginView } from './views/LoginView'
import { NotAuthorizedView } from './views/NotAuthorizedView'

// AppGate: the ONLY place that decides what renders.
// It blocks ALL data-bearing UI until the bootstrap whoami resolves.
function AppGate() {
  const { status } = useAdminState()

  if (status === 'loading') {
    return (
      <div
        role="status"
        aria-label="Loading"
        aria-live="polite"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          color: 'var(--admin-text-muted)',
          fontFamily: 'var(--admin-font)',
        }}
      >
        <span>Loading…</span>
      </div>
    )
  }

  if (status === 'unauthenticated') return <LoginView />
  if (status === 'forbidden') return <NotAuthorizedView />
  return <Shell />
}

export default function App() {
  // QueryClient created per-instance so tests that render App multiple times
  // start with a clean cache each time.
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { retry: 1, staleTime: 30_000 },
          mutations: { retry: 0 },
        },
      }),
  )

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AdminProvider>
          <AppGate />
        </AdminProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
